import { ExclamationCircleFilled, RightOutlined, UploadOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Modal, Row, Typography, Upload } from "antd";
import CustomButton from "components/CustomButton";
import CustomModal from "components/CustomModal";
import FormInput from "components/FormInput";
import PageHeader from "components/PageHeader";
import { INPUT_TYPE } from "config/constants";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { TitleCard } from "./components/TitleCard";
import "./index.scss";
import useCreate from "./useCreate";

function CreateContract() {
  const {
    form,
    handleFinish,
    initialValues,
    history,
    loadingCreate,
    sellerOptions,
    staffOptions,
    contractTypeOptions,
    hasMoreSellerOptions,
    loadMoreSellerOptions,
    onSearchSeller,
    hasMoreStaffOptions,
    loadMoreSalesmen,
    onSearchSalesman,
    isConflictModalVisible,
    conflictContract,
    loadingResolveConflict,
    handleCloseConflictModal,
    handleDisableAndContinueCreate,
    setIsSaveAndAddNew,
    handleResetForm,
    shouldResetPreview,
    setShouldResetPreview,
  } = useCreate();
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (shouldResetPreview) {
      setPreviewUrl(null);
      setShouldResetPreview(false);
    }
  }, [shouldResetPreview, setShouldResetPreview]);

  return (
    <div className="create-recommend-import">
      <Form layout="vertical" form={form} onFinish={handleFinish} initialValues={initialValues}>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <PageHeader
              pageTitle="Thêm mới hợp đồng"
              routes={[
                { path: "#", name: "Đại lý" },
                { path: "/list-contract", name: "Hợp đồng" },
                { path: "/", name: "Thêm mới hợp đồng" },
              ]}
            />
          </Col>

          <Col span={24}>
            <Row gutter={[16, 8]}>
              <Col span={24} className="card-container-info">
                <Card title={<TitleCard title="THÔNG TIN HỢP ĐỒNG" />} style={{ flexGrow: 1 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.INPUT}
                        formItemOptions={{
                          label: <Typography.Text strong>Mã hợp đồng</Typography.Text>,
                          name: "contractCode",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng nhập mã hợp đồng",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "Nhập mã hợp đồng",
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.SELECT_LOAD_MORE}
                        formItemOptions={{
                          label: <Typography.Text strong>Đại lý</Typography.Text>,
                          name: "agentId",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng chọn đại lý",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "Chọn đại lý",
                          options: sellerOptions,
                          optionFilterProp: "label",
                        }}
                        onLoadMore={loadMoreSellerOptions}
                        hasMoreData={hasMoreSellerOptions}
                        onSearch={onSearchSeller}
                      />
                    </Col>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.SELECT}
                        formItemOptions={{
                          label: <Typography.Text strong>Loại hợp đồng</Typography.Text>,
                          name: "contractType",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng chọn loại hợp đồng",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "Chọn loại hợp đồng",
                          options: contractTypeOptions,
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.DATE_PICKER}
                        formItemOptions={{
                          label: <Typography.Text strong>Ngày ký</Typography.Text>,
                          name: "signDate",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng chọn ngày ký",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "01/09/2024",
                          format: "DD/MM/YYYY",
                          style: { width: "100%" },
                          disabledDate: (current) => current && current.isAfter(moment(), "day"),
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.DATE_PICKER}
                        formItemOptions={{
                          label: <Typography.Text strong>Ngày hết hạn</Typography.Text>,
                          name: "expiryDate",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng chọn ngày hết hạn",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "01/09/2024",
                          format: "DD/MM/YYYY",
                          style: { width: "100%" },
                          disabledDate: (current) => current && current.isBefore(moment(), "day"),
                        }}
                      />
                    </Col>
                    <Col span={8}>
                      <FormInput
                        type={INPUT_TYPE.SELECT_LOAD_MORE}
                        formItemOptions={{
                          label: <Typography.Text strong>Người lập hợp đồng</Typography.Text>,
                          name: "creatorId",
                          rules: [
                            {
                              required: true,
                              message: "Vui lòng chọn người lập hợp đồng",
                            },
                          ],
                        }}
                        inputOptions={{
                          placeholder: "Nhập tên người lập hợp đồng",
                          options: staffOptions,
                          optionFilterProp: "label",
                        }}
                        onLoadMore={loadMoreSalesmen}
                        hasMoreData={hasMoreStaffOptions}
                        onSearch={onSearchSalesman}
                      />
                    </Col>
                    <Col span={24}>
                      <FormInput
                        type={INPUT_TYPE.TEXT_AREA}
                        formItemOptions={{
                          label: <Typography.Text strong>Ghi chú</Typography.Text>,
                          name: "note",
                        }}
                        inputOptions={{
                          placeholder: "Nhập nội dung ghi chú...",
                          rows: 4,
                        }}
                      />
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label={<Typography.Text strong>File hợp đồng</Typography.Text>}
                        name="contractFile"
                        rules={[
                          {
                            required: true,
                            message: "Vui lòng tải lên file hợp đồng",
                          },
                        ]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          if (Array.isArray(e)) {
                            return e;
                          }
                          return e?.fileList;
                        }}
                      >
                        <Upload.Dragger
                          beforeUpload={() => false}
                          maxCount={1}
                          accept=".pdf,.doc,.docx"
                          showUploadList={false}
                          onChange={(info) => {
                            const file = info.fileList[0];
                            if (file) {
                              const url = URL.createObjectURL(file.originFileObj);
                              setPreviewUrl(url);
                            } else {
                              setPreviewUrl(null);
                            }
                          }}
                          style={{
                            background: "#fafafa",
                            border: "1px dashed #d9d9d9",
                            borderRadius: "2px",
                          }}
                        >
                          {previewUrl ? (
                            <div style={{ position: "relative" }}>
                              <iframe
                                src={previewUrl}
                                style={{
                                  width: "100%",
                                  height: "842px",
                                  border: "none",
                                }}
                                title="PDF Preview"
                              />
                              <Button
                                danger
                                size="small"
                                style={{
                                  position: "absolute",
                                  top: 10,
                                  right: 10,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPreviewUrl(null);
                                  form.setFieldsValue({ contractFile: [] });
                                }}
                              >
                                Xóa file
                              </Button>
                            </div>
                          ) : (
                            <div style={{ padding: "20px 0" }}>
                              <p style={{ margin: "0 0 8px 0", color: "#666", fontSize: 14 }}>
                                Chọn file hợp đồng có đuôi .pdf
                              </p>
                              <Button icon={<UploadOutlined />}>Tải file lên</Button>
                            </div>
                          )}
                        </Upload.Dragger>
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col span={24} style={{ marginBottom: "30px" }}>
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <Row gutter={[16, 8]}></Row>
              </Col>
              <Col span={24}>
                <Card className="form-footer">
                  <CustomModal
                    {...{
                      customComponent: <CustomButton title={t("common.cancel")} />,
                      footer: false,
                      message: "Bạn có chắc chắn muốn hủy tạo hợp đồng này?",
                      centered: true,
                      onOke: () => {
                        history.push("/list-contract");
                      },
                    }}
                  />
                  <Modal
                    visible={isConflictModalVisible}
                    onCancel={handleCloseConflictModal}
                    footer={null}
                    centered
                    width={600}
                    closable={true}
                    className="contract-conflict-modal"
                  >
                    <div style={{ textAlign: "center", padding: "24px 24px 0" }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>
                        Đại lý bạn chọn đã có hợp đồng nguyên tắc
                      </h3>
                      <WarningOutlined style={{ fontSize: 48, color: "#faad14", marginBottom: 8 }} />
                      <p style={{ color: "#666", fontSize: 14, marginBottom: 24 }}>
                        Hiện tại đại lý bạn chọn đã có hợp đồng nguyên tắc đang còn hiệu lực. Vui lòng kiểm tra trước khi thêm hợp đồng mới.
                        {/* <br /> */}
                        {/* Hãy kiểm tra trước khi thêm hợp đồng mới */}
                      </p>
                    </div>

                    <div
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        padding: 20,
                        margin: "0 24px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "140px 1fr",
                          rowGap: 12,
                          columnGap: 16,
                        }}
                      >
                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Mã hợp đồng</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>{conflictContract?.code}</div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Trạng thái</div>
                        <div style={{ color: "#52c41a", fontWeight: 500, fontSize: 14 }}>Còn hiệu lực</div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Đại lý</div>
                        <div style={{ color: "#1890ff", fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.seller?.fullName || conflictContract?.sellerID}
                        </div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Loại hợp đồng</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.type === "FRAMEWORK_AGREEMENT"
                            ? "Hợp đồng nguyên tắc"
                            : "Hợp đồng mua bán"}
                        </div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Người tạo</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.createdBy?.fullname || "-"}
                        </div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Ngày ký</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.startDate
                            ? new Date(conflictContract.startDate).toLocaleDateString("vi-VN")
                            : "-"}
                        </div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Hết hạn</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.endDate
                            ? new Date(conflictContract.endDate).toLocaleDateString("vi-VN")
                            : "-"}
                        </div>

                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 14 }}>Người lập hợp đồng</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.drafterBy?.fullname || "-"}
                        </div>

                        <div style={{ color: "#666", fontSize: 14 }}>File hợp đồng</div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>
                          {conflictContract?.fileURL ? (
                            <a
                              href={conflictContract.fileURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#1783e8ff", fontStyle: "italic", textDecoration: "underline" }}
                            >
                              Click để xem
                            </a>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ padding: "24px 24px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
                      <Button
                        type="primary"
                        block
                        loading={loadingResolveConflict}
                        onClick={handleDisableAndContinueCreate}
                        style={{ borderRadius: 8, height: 40, fontWeight: 500 }}
                      >
                        Vô hiệu hóa hợp đồng này và Tiếp tục tạo mới hợp đồng
                      </Button>
                      <Button
                        block
                        onClick={handleCloseConflictModal}
                        style={{ borderRadius: 8, height: 40, color: "#666" }}
                      >
                        Hủy bỏ
                      </Button>
                    </div>
                  </Modal>
                  <CustomButton
                    type={"primary"}
                    title={t("common.create") || "Tạo mới"}
                    htmlType={"submit"}
                    loading={loadingCreate}
                  />
                  <CustomButton
                    type={"primary"}
                    title="Lưu & Thêm mới"
                    htmlType={"submit"}
                    loading={loadingCreate}
                    onClick={() => {
                      setIsSaveAndAddNew(true);
                    }}
                  />
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default CreateContract;
